import { handleVersionMismatch } from 'actions/versionSync';
import { FETCH_OUTFIT_FAILURE, FETCH_OUTFIT_REQUESTED, FETCH_OUTFIT_SUCCESS, } from 'actiontypes/myself';
import { VersionMismatch } from 'services/BaseService';
import MyselfService from 'services/MyselfService';
import { IFetchOutfitResponseData, IMyselfService } from 'types/myself';

/** ----------------------------------------------------------------------------
 * FETCH OUTFIT
 -----------------------------------------------------------------------------*/

export default fetchOutfit(new MyselfService());

export function fetchOutfit(service: IMyselfService) {
  return () => async (dispatch: Function) => {
    dispatch(fetchOutfitRequested());

    try {
      const { data } = await service.fetchOutfit();
      dispatch(fetchOutfitSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      dispatch(fetchOutfitFailure(error));
      throw error;
    }
  };
}

const fetchOutfitRequested = () => ({
  type: FETCH_OUTFIT_REQUESTED,
});

const fetchOutfitSuccess = (data: IFetchOutfitResponseData) => ({
  type: FETCH_OUTFIT_SUCCESS,
  payload: data,
});

const fetchOutfitFailure = (error: any) => ({
  type: FETCH_OUTFIT_FAILURE,
  error: true,
  status: error.response && error.response.status,
});